import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { SessionStore } from '../../shared/stores/session.store';
import { authGuard } from './auth.guard';
import { AuthService } from '../../shared/services/auth.service';
import { map, take } from 'rxjs';

/**
 * Use on the login route. If the user already has a valid session, redirects to home.
 * While session is loading (undefined), allows so the app can show the loading spinner.
 */
export const alreadyAuthGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const sessionStore = inject(SessionStore);
  const router = inject(Router);
  const session = sessionStore.currentSession();

  if (session !== undefined) {
    return session !== null ? router.createUrlTree(['/']) : true;
  }

  return auth.loadSession().pipe(
    take(1),
    map((s) => (s !== null ? router.createUrlTree(['/']) : true)),
  );
};
